const mappedProductStorage = (data) => {
  return data?.productStorages?.map((item) => {
    return {
      name: item?.storage?.name,
      stock: item?.availableStock,
      isActive: item?.storage?.status === 'Aktif',
    };
  });
};
export default mappedProductStorage;
